import { render } from "./SubjectsList.vue?vue&type=template&id=fc7c2406&scoped=true"
import script from "./SubjectsList.vue?vue&type=script&lang=js"
export * from "./SubjectsList.vue?vue&type=script&lang=js"

import "./SubjectsList.vue?vue&type=style&index=0&id=fc7c2406&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc7c2406"]])

export default __exports__